import { Component, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { GlobalApp } from "../../Helpers/global";
import { Router } from "@angular/router";
import { MenuUsersService } from "../../Services/menu-users.service";
import { MenuUsers } from "../../Model/menu-users";

@Component({
  selector: "navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.css"],
})
export class NavbarComponent implements OnInit, OnChanges {
  private menuUsersList: MenuUsers[] = [];

  constructor(
    public app: GlobalApp,
    private _route: Router,
    private menuUsersService: MenuUsersService
  ) {}

  ngOnInit() {
    this.menuUsersService.getAll().subscribe(
      (response) => {
        if (response.length > 0) {
          this.menuUsersList = response;
        } else {
          this.menuUsersList = null;
        }
      },
      (error) => {}
    );
  }

  ngOnChanges() {}

  hasAccessTo(menu: string): boolean {
    let hasAccess = false;
    hasAccess =
      this.menuUsersList.filter((data) => {
        return (
          data.menuName == menu && data.user == localStorage.getItem("user")
        );
      }).length > 0;

    return hasAccess;
  }

  logout() {
    localStorage.clear();
    this._route.navigate(["/b2blogin"]);
  }
}
